import React, { Component } from 'react'
import { connect } from 'react-redux'

import BkQueryGuestFieldAdults from './BkFlowEditGuestFieldAdults'
import BkQueryGuestFieldChildren from './BkFlowEditGuestFieldChildren'
import BkQueryGuestFieldDogs from './BkFlowEditGuestFieldDogs'
import BkQueryGuestFieldCats from './BkFlowEditGuestFieldCats'

import setActiveGuest from '../../../../actions/setEditStayGuest'
import removeActiveGuest from '../../../../actions/removeEditStayGuest'
import _ from 'lodash'

class BkFlowEditGuestFieldInputs extends Component {

	constructor(props) {
		super(props)
		const {
			roomGroup,
			handleSetGuest
		} = props

		let flowGuestData = null,
				adultsVal = 1,
				childrenVal = 0,
				dogVal = false,
				catVal = false

		if (localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

		// set adults by flowGuestData
		if (
			flowGuestData &&
			flowGuestData[roomGroup] &&
			flowGuestData[roomGroup].adults
		) {
			adultsVal = flowGuestData[roomGroup].adults
		}

		// set children by flowGuestData
		if (
			flowGuestData &&
			flowGuestData[roomGroup] &&
			flowGuestData[roomGroup].children
		) {
			childrenVal = flowGuestData[roomGroup].children
		}

		// set dogs by flowGuestData
		if (
			flowGuestData &&
			flowGuestData[roomGroup] &&
			flowGuestData[roomGroup].dogs
		) {
			dogVal = flowGuestData[roomGroup].dogs
		}

		// set cats by flowGuestData
		if (
			flowGuestData &&
			flowGuestData[roomGroup] &&
			flowGuestData[roomGroup].cats
		) {
			catVal = flowGuestData[roomGroup].cats
		}

		// Default and minimum guest values
		this.state = {
			currentAdults: adultsVal,
			currentChildren: childrenVal,
			enableDogs: dogVal,
			enableCats: catVal,
		}

		const {
			currentAdults,
			currentChildren,
			enableDogs,
			enableCats
		} = this.state

		// Dispatch initial guest data on mount
		handleSetGuest(
			roomGroup,
			currentAdults,
			currentChildren,
			enableDogs,
			enableCats
		)
	}

	// Handle removal of guest group in window session and state on un-mount
	componentWillUnmount() {
		const {
			roomGroup,
			handleRemoveGuest
		} = this.props

		handleRemoveGuest(roomGroup)
	}


	// Increment total adults
	addAdult = () => {
		const {
			roomGroup,
			editStayGuestData,
			handleSetGuest
		} = this.props

		// Previous editStayGuestData
		const currentGuestGroup = editStayGuestData[roomGroup]

		// Dispatch updated adults value, and previous existing guest data
		handleSetGuest(
			roomGroup,
			this.state.currentAdults + 1,
			currentGuestGroup.children,
			currentGuestGroup.dogs,
			currentGuestGroup.cats
		)

		// Handle adults increment state
		this.setState({
			currentAdults: this.state.currentAdults + 1
		})
	}

	// Decrement total adults
	removeAdult = () => {
		const {
			roomGroup,
			editStayGuestData,
			handleSetGuest
		} = this.props

		// Previous editStayGuestData
		const currentGuestGroup = editStayGuestData[roomGroup]

		// Dispatch updated adults value, and previous existing guest data
		handleSetGuest(
			roomGroup, this.state.currentAdults - 1,
			currentGuestGroup.children,
			currentGuestGroup.dogs,
			currentGuestGroup.cats
		)

		// Handle adults Decrement state
		this.setState({
			currentAdults: this.state.currentAdults - 1
		})
	}


	// Increment total children
	addChild = () => {
		const {
			roomGroup,
			editStayGuestData,
			handleSetGuest
		} = this.props

		// Previous editStayGuestData
		const currentGuestGroup = editStayGuestData[roomGroup]

		// Handle adults increment state
		this.setState({
			currentChildren: this.state.currentChildren + 1
		})

		// Dispatch updated children value, and previous existing guest data
		handleSetGuest(
			roomGroup,
			currentGuestGroup.adults,
			this.state.currentChildren + 1,
			currentGuestGroup.dogs,
			currentGuestGroup.cats
		)
	}

	// Decrement total children
	removeChild = () => {
		const {
			roomGroup,
			editStayGuestData,
			handleSetGuest
		} = this.props

		// Previous editStayGuestData
		const currentGuestGroup = editStayGuestData[roomGroup]

		// Handle adults Decrement state
		this.setState({
			currentChildren: this.state.currentChildren - 1
		})

		// Dispatch updated children value, and previous existing guest data
		handleSetGuest(
			roomGroup,
			currentGuestGroup.adults,
			this.state.currentChildren - 1,
			currentGuestGroup.dogs,
			currentGuestGroup.cats
		)
	}

	// Handle dogs state
	toggleDogs = () => {
		const {
			roomGroup,
			editStayGuestData,
			handleSetGuest
		} = this.props

		// Previous dogs state
		const currentGuestGroup = editStayGuestData[roomGroup]

		// Handle dogs toggle state
		this.setState({
			enableDogs: !this.state.enableDogs
		})

		// Dispatch updated dogs value, and previous existing guest data
		handleSetGuest(
			roomGroup,
			currentGuestGroup.adults,
			currentGuestGroup.children,
			!this.state.enableDogs,
			currentGuestGroup.cats
		)
	}

	// Handle cats state
	toggleCats = () => {
		const {
			roomGroup,
			editStayGuestData,
			handleSetGuest
		} = this.props

		// Previous cats state
		const currentGuestGroup = editStayGuestData[roomGroup]

		// Handle cats toggle state
		this.setState({
			enableCats: !this.state.enableCats
		})

		// Dispatch updated cats value, and previous existing guest data
		handleSetGuest(
			roomGroup,
			currentGuestGroup.adults,
			currentGuestGroup.children,
			currentGuestGroup.dogs,
			!this.state.enableCats
		)
	}

	render() {
		const {
			closeGuestInputs,
			configData,
			editStayHotelCode,
			guestInputsExpanded,
			isCatsFieldVisible,
			isDogsFieldVisible,
			roomGroup,
		} = this.props

		// Window session for query reservation config
		let flowQueryConfig = null

		if (localStorage.flowQueryConfig) {
			flowQueryConfig = JSON.parse(localStorage.flowQueryConfig)
		} else {
			flowQueryConfig = {
				enableCats: true,
				enableDogs: true
			}
		}

		// Get hotel code from url
		let currentFlowQueryProperty = null
		let currentConfigurationProperty = null

		if (
			flowQueryConfig &&
			flowQueryConfig.supportedProperties &&
			editStayHotelCode
		) {
			const matchedProperty = flowQueryConfig.supportedProperties.filter(function(property){
				return property.hotelCode === editStayHotelCode
			})
			currentFlowQueryProperty = matchedProperty[0]
		}

		if (
			flowQueryConfig &&
			flowQueryConfig.supportedProperties &&
			editStayHotelCode
		) {
			const matchedProperty = flowQueryConfig.supportedProperties.filter(function(property){
				return property.hotelCode === editStayHotelCode
			})

			currentFlowQueryProperty = matchedProperty[0]
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			currentConfigurationProperty = configProperties.find(function(property) {
				return property.hotelCode === String(editStayHotelCode)
			})
		}

		return (
			<div className={ guestInputsExpanded ? "bk-flow-edit-guest__field-inputs active" : "bk-flow-edit-guest__field-inputs" }>
				<button
					aria-label="Close"
					className="bk-flow-edit-guest__close u-font-medium"
					onClick={ () => closeGuestInputs() }
				>
					&times;
				</button>

				<BkQueryGuestFieldAdults
					roomGroup={ roomGroup }
					sessionProperty={currentFlowQueryProperty}
					configProperty={currentConfigurationProperty}
					currentAdults={ this.state.currentAdults }
					currentChildren={ this.state.currentChildren }
					addAdult={ this.addAdult }
					removeAdult={ this.removeAdult }
				/>

				<BkQueryGuestFieldChildren
					roomGroup={ roomGroup }
					sessionProperty={currentFlowQueryProperty}
					configProperty={currentConfigurationProperty}
					currentAdults={ this.state.currentAdults }
					currentChildren={ this.state.currentChildren }
					addChild={ this.addChild }
					removeChild={ this.removeChild }
				/>

				{ isDogsFieldVisible || isCatsFieldVisible ?
					<div className="bk-flow-edit-guest__field-pets row">

						{ isDogsFieldVisible &&
							<BkQueryGuestFieldDogs
								roomGroup={ roomGroup }
								enableDogs={ this.state.enableDogs }
								toggleDogs={ this.toggleDogs }
							/>
						}

						{ isCatsFieldVisible &&
							<BkQueryGuestFieldCats
								roomGroup={ roomGroup }
								enableCats={ this.state.enableCats }
								toggleCats={ this.toggleCats }
							/>
						}

					</div>
				:
					null
				}

			</div >
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration,
	urlData: state.availabilityData.urlData,
	editStayHotelCode: state.editStayPropertyData.activeHotelCode,
	editStayGuestData: state.editStayGuestData
})

const mapDispatchToProps = dispatch => ({
	handleSetGuest(roomGroup, adults, children, dogs, cats) {
		return dispatch(setActiveGuest(roomGroup, adults, children, dogs, cats))
	},
	handleRemoveGuest(roomGroup) {
		return dispatch(removeActiveGuest(roomGroup))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowEditGuestFieldInputs)


// WEBPACK FOOTER //
// ./src/components/edit/guest/elements/BkFlowEditGuestFieldInputs.js